// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3Qj45","footer":"ModalInfo_footer__2yRVV"};